import { useCallback, useState } from 'react'
import { TitleSButtonPermissioned } from '../../../../../../../baseComponents/Layout/TitleAndRightLayout'
import { VerticalSortItem } from '../../../../../../../baseComponents/Sorts/VerticalSortList/types'
import { VirtualTableListingStateLess } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing'
import { CustomRenderIcon, DeleteRow } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import useEditDeleteModal from '../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { dictIcon } from '../../../../../../../utils/icons'
import ModalCEEmployeeQuickAccess from './ModalCEEmployeeQuickAccess'
import { ModalDeleteEmployeeQuickAccess } from './ModalDeleteEmployeeQuickAccess'
import ModalSortEmployeeQA from './ModalSortEmployeeQA'
import { getEmployeeQuickAccessParam } from '../../../../../../../utils/reducers/getters'


interface EmployeeQuickAccessProps {}

const EmployeeQuickAccess: React.FC<EmployeeQuickAccessProps> = () => {
    const { openModal, setOpenModal, data, onSubmit } = useEmployeeQuickAccessLogic()
    const {t} = useTwinTranslation()
    const pageData = {
        title: t('quickAccess', 'Acceso rápido'),
        newText: t('addQuickAccess', 'Añadir acceso rápido'),
    }
    const columns: ColumnTableSchema<TwinDictionary> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre')
        },
        {
            id: 'icon',
            dataKey: 'icon',
            label: t('icon', 'Icono'),
            customRender: (parameterValue) => <CustomRenderIcon icon={dictIcon[parameterValue]} />
        },
        {
            id: 'order',
            dataKey: 'order',
            label: t('order', 'Orden')
        },
        {
            id: 'delete',
            dataKey: 'delete',
            label:'',
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpenModal({ type: 'delete', allRowData })} />,
            width: 30
        }
    ]
    return (
        <TitleSButtonPermissioned  title={pageData.title} buttonText={pageData.newText} userPermissions={{n: 4, permission: 'delete'}} onClick={() => setOpenModal({ type: 'create', allRowData: {} })}>
            <div className='flex justify-end mb-20'>
                <ModalSortEmployeeQA onSubmit={onSubmit} />
            </div>
            <div className='flex flex-auto flex-col'>
                <VirtualTableListingStateLess tableData={data || []} name='EmployeeQuickAccess' columns={columns} setSelectedColumnsAndFilters={() => { }} />
            </div>
            {openModal?.type === 'create' && <ModalCEEmployeeQuickAccess {...{ setOpened: () => setOpenModal(null) }} onSubmit={onSubmit} />}
            {openModal?.type === 'delete' && <ModalDeleteEmployeeQuickAccess {...{ setOpened: () => setOpenModal(null) }} onSubmit={onSubmit} allRowData={openModal?.allRowData} />}
        </TitleSButtonPermissioned>
    )
}

const useEmployeeQuickAccessLogic = () => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const [data, setData] = useState<VerticalSortItem[] | null>(getEmployeeQuickAccessParam())
    const onSubmit = useCallback(() => {
        setData(getEmployeeQuickAccessParam())
    }, [setData])

    return { openModal, setOpenModal, data, setData, onSubmit }
}

export default EmployeeQuickAccess